/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { Icon } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import { Filter } from 'views/curatedViews/Filter';
import LegendTitle from 'components/legendV2/LegendTitle';

export function ControlsContainer({hideLabels, 
                                   toggleLabels, 
                                   filterOptions,
                                   enableLabelsToggle,
								   legendItemProps
                                }) {

	return (
		<div className='flex-row' css={controlsContainerCss}>
			{enableLabelsToggle ? <Icon icon={hideLabels ? IconNames.EYE_OFF : IconNames.EYE_OPEN} onClick={toggleLabels}/> : null}
			{filterOptions ? <Filter {...filterOptions}/> : null}
			{legendItemProps ? <LegendTitle legendItemProps={legendItemProps}/> : null}
		</div>
	)
}

const controlsContainerCss = css`
	justify-content: center;
	align-items: center;

	& .bp3-icon {
		color: #6699CC;
	}
	
	& > * {
		padding: 1px 9px;
		cursor: pointer;
		
		&:not(:last-child) {
			border-right: 1px solid #d0d0d0;
		}
	}
`